import React from "react";
import { useSelector } from "react-redux";
import PageHeader from "../PageHeader";
import Checklist from "../../Checklist";
import Cart from "../../Cart";
import PageForm from "../PageForm";
import PageTabs from "../PageTabs";
import * as ProjectSelectors from "store/project/projectSelectros";
import * as OrderSelectors from "store/order/orderSelectors";
import AIQuote from "modules/ai-quote";
import QuoteTab from "modules/ai-quote/components/QuoteTab";

export const pageGenerator = (projectsTypes) => {
  return projectsTypes.reduce((accumulator, projectType) => {
    const Component = () => {
      const projectDetails = useSelector(ProjectSelectors.selectProjectDetails);
      const selectChecklists = useSelector(ProjectSelectors.selectChecklist);
      const ordersIsProcessing = useSelector(
        OrderSelectors.selectOrderIsProcessing
      );
      const {
        headTitle,
        headMetaDescription,
        headSchema,
        headerTitle,
        headerLogo,
        headerDescription,
        customClass,
        checklist,
        checklistTabs = [],
        isAIQuotePage = false,
        tabs,
      } = projectDetails;

      return (
        <div
          className={`app-project-main ${customClass} ${
            ordersIsProcessing ? "is-processing" : ""
          }`}
        >
          <PageHeader
            headerTitle={headerTitle}
            headerLogo={headerLogo}
            headerDescription={headerDescription}
          />
          <div className="app-project-content">
            <PageTabs
              headTitle={headTitle}
              headMetaDescription={headMetaDescription}
              headSchema={headSchema}
              checklist={checklist}
              checklistTabs={checklistTabs}
            />
            {tabs && <QuoteTab tabs={tabs} />}
            <div className="app-columns-wrapper">
              <div className="app-container">
                {!isAIQuotePage ? (
                  <div className="app-columns">
                    <div className="app-column-left">
                      <Checklist checklist={selectChecklists} />
                      <PageForm />
                    </div>
                    <div className="app-column-right">
                      <Cart />
                    </div>
                  </div>
                ) : (
                  <AIQuote />
                )}
              </div>
            </div>
          </div>
        </div>
      );
    };

    accumulator[projectType] = <Component />;
    return accumulator;
  }, {});
};
